<template>
  <el-dialog
      :visible.sync="visible"
      title="目的港调整"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
      :append-to-body="true"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="120px"
        :rules="dataRule"
    >
      <el-form-item prop="receiptCode" label="出口发票号：">
       {{dataForm.receiptCode}}
      </el-form-item>
      <el-form-item prop="destination" label="目的港：">
        <dict-dropdown v-model="dataForm.destination" size="mini" dictName="harbour"
                       :default-item="null"
                       style="width: 200px;"
                       :filterable="true" class="bar-item"></dict-dropdown>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import DictDropdown from '@/components/DictDropdown/index.vue'
export default {
  name: 'destination-dialog',
  components: {DictDropdown},
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        destination: '',
        receiptCode:''
      },
      dataRule: {
        destination: [
          { required: true, message: '请选择目的港', trigger: 'change' },
        ],
      }
    }
  },
  methods: {
    open (id, destination,receiptCode) {
      this.visible = true
      this.dataForm.id = id
      this.dataForm.destination = destination
      this.dataForm.receiptCode = receiptCode
    },
   async dataFormSubmitHandle () {
      const postForm={
        ...this.dataForm
      }
      const res = await this.$api2.post(`/erp/box/destination`, postForm)
      this.$emit('changed')
      this.visible = false
    }
  }
}
</script>

<style scoped>

</style>
